import type { ReactNode } from 'react';

/** A routed page. Kept-alive pages (the maps) stay mounted while hidden. */
export function View({ id, active = true, className = '', children }: { id: string; active?: boolean; className?: string; children: ReactNode }) {
  return <section id={id} className={`view${className ? ` ${className}` : ''}`} hidden={!active}>{children}</section>;
}

/** Page title block: eyebrow, title and summary on the left, page actions on the right. */
export function PageHeading({ eyebrow, title, subtitle, children }: { eyebrow: string; title: ReactNode; subtitle?: ReactNode; children?: ReactNode }) {
  return (
    <header className="page-heading">
      <div className="page-heading-text"><p className="eyebrow">{eyebrow}</p><h1>{title}</h1>{subtitle && <p className="page-summary">{subtitle}</p>}</div>
      {children && <div className="page-actions">{children}</div>}
    </header>
  );
}

/** Title row of a panel, with optional actions on the right. */
export function PanelHeader({ title, summary, children }: { title: ReactNode; summary?: ReactNode; children?: ReactNode }) {
  return (
    <header className="panel-header">
      <div className="panel-heading-text"><h2>{title}</h2>{summary && <p>{summary}</p>}</div>
      {children && <div className="panel-actions">{children}</div>}
    </header>
  );
}

/** A muted placeholder for an empty list or panel. */
export function EmptyState({ children }: { children: ReactNode }) {
  return <p className="empty-state">{children}</p>;
}
